export default {
  TitleControl: '',
  ShowTitleControl: { checked: false },
  StyleTitleControl: {
    fontSize: 20,
    color: '#000000',
    fontFamily: 'arial',
    bold: false,
    italic: false,
    underline: false,
    align: 'center',
  },
  type: 'Table',
};
